export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-star-line',
      title: 'Calidad Garantizada',
      description: 'Trabajamos con las mejores marcas del mercado como Roly y Valento para asegurar productos de máxima calidad.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Personalización Total',
      description: 'Amplia gama de colores y tallas disponibles. Perfecto para serigrafía, bordado y transfer.'
    },
    {
      icon: 'ri-time-line',
      title: 'Entrega Rápida',
      description: 'Procesamos y enviamos tu pedido en 24-48 horas. Stock permanente de todos nuestros productos.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atención Personalizada',
      description: 'Asesoramiento experto para ayudarte a elegir los productos perfectos para tu proyecto.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ¿Por Qué Elegirnos?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Somos especialistas en ropa personalizada al por mayor con años de experiencia en el sector
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}